module.exports = __webpack_public_path__ + "img/visit-approval-success.4d218bf5.png";